module.exports = __webpack_public_path__ + "img/teddy-bear.61c8d18f.svg";